import html from "./sb_share_options.component.html";
import SbShareOptionsCtrl from "./sb_share_options.controller";
import angular from "angular";
import "angular-ui-router";
import "common/intercom/intercomModule";
import "common/services/services";

export default angular
    .module("sbApp.common.components.shareOptions", ["ngMaterial"])
    .component("sbShareOptions", {
        templateUrl: html,
        controller: SbShareOptionsCtrl,
        controllerAs: "$ctrl",
    });
